import { render, staticRenderFns } from "./EliminarTiquete.vue?vue&type=template&id=2fcaf619&dark=true"
import script from "./EliminarTiquete.vue?vue&type=script&lang=js"
export * from "./EliminarTiquete.vue?vue&type=script&lang=js"
import style0 from "./EliminarTiquete.vue?vue&type=style&index=0&id=2fcaf619&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports